import React from "react"
import ReactDOM from "react-dom/client"
import "bootstrap/dist/css/bootstrap.min.css"
import { Provider } from "react-redux"
import { store } from "./app/store"
import { setPendingService } from "./features/PostCreat/postcreateSlice"
import App from "./App"
import "./index.css"
import { globalToastStyle, progressStyle } from "./toastStyles"
import "react-toastify/dist/ReactToastify.css"
import { ToastContainer } from "react-toastify"
import ReactGA from "react-ga4"

const GA_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID || "G-VEQLQ0QMPB"
if (GA_ID) {
  ReactGA.initialize(GA_ID)
}

// Capture the service chosen on the landing page (?service=) into the store
// before the auth redirect strips the query string, so it can be pre-selected
// on the service-selection screen after login.
const pendingService = new URLSearchParams(window.location.search).get("service")
if (pendingService) {
  store.dispatch(setPendingService(pendingService))
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ToastContainer
        toastStyle={globalToastStyle}
        autoClose={1500}
        progressStyle={progressStyle}
        closeButton={true}
      />
      <App />
    </Provider>
  </React.StrictMode>,
)
